const Header = () => {
  return (
    <footer>
      <div class="copyright">
        <p>Copyright © 2023 調和系工学研究室 - <br class="tb_br" />北海道大学 大学院情報科学研究院 <br class="sp_br" />情報理工学部門 複合情報工学分野</p>
      </div>
    </footer>
  );
};

export default Header;
